export { default } from './TabPanel';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/lab/esm/TabPanel/index.js
// module id = 893
// module chunks = 2